export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    datePickerConfig: {
      nextMonthCaption: 'Próximo mês',
      prevMonthCaption: 'Mês anterior',
      setTimeCaption: 'Hora',
      weekdays: [
        'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
      ],
      months: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]
    },
    coupon: {
      code: '',
      validFrom: null,
      validUntil: null,
      amount: 0,
      type: 'fixed_amount',
      quantity: null,
      firstPurchaseOnly: false,
      maxUsesPerPerson: null,
      paymentMethod: null,
      minimumAmount: null,
      minimumTravelers: null,
    },
    types: [
      {
        value: 'fixed_amount',
        label: 'Valor fixo'
      },
      {
        value: 'percent',
        label: 'Porcentagem'
      },
    ],
    paymentMethods: [
      {
        value: null,
        label: 'Todos'
      },
      {
        value: 'credit_card',
        label: 'Cartão de Crédito'
      },
      {
        value: 'pix',
        label: 'Pix'
      },
    ],
  }
}
